import { ExcelOptions } from "../models/excel-options";
import { IExcelParser } from "./iexcel-parser";

export class DefaultParser implements IExcelParser {
    parse(data: any[], config: ExcelOptions) {
        throw new Error("Method not implemented.");
    }
}
